import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { connect } from "react-redux";
import { CtrlCollection } from "@yuigoto/ctrl";

import RegisterFormStyles from "components/login/LoginForm.module.scss";
import { TokenActions } from "state/actions/user/TokenActions";
import { GlamboxLoginRenderer } from "components/renderers/GlamboxLoginRenderer";
import { RegisterControl } from "controls/RegisterControl";
import { UiActions } from "state/actions/UiActions";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";

class RegisterForm extends Component {
  constructor (props) {
    super(props);

    this.collection = new CtrlCollection();
    for (let i in RegisterControl) {
      this.collection.add(RegisterControl[i]);
    }

    this.state = {
      pendingRequest: false
    };
  }

  render () {
    let isLoginDisabled = this.state.pendingRequest;
    
    return (
      <form className={RegisterFormStyles["login-form"]} onSubmit={this.submitData}>
        {GlamboxLoginRenderer.renderCollection(this.collection)}

        <div className={"login-form__submit-group"}>
          <NavLink to={"/"} className={classnames("btn", "btn-outline-white")}>
            Voltar
          </NavLink>
          &nbsp;
          <button type={"submit"} 
                  className={classnames("btn", "btn-light-lime", "login-form__submit")}
                  disabled={isLoginDisabled}>
            Cadastrar
          </button>
        </div>
      </form>
    );
  }
  
  // --------------------------------------------------------------------
  
  submitData = (e) => {
    e.preventDefault();
    
    let password = this.collection.getValue("password"),
        passwordConfirmation = this.collection.getValue("passwordConfirmation");
    
    let isValid = this.collection.validate();
    
    if (!isValid) {
      this.forceUpdate();
    } else if (password !== passwordConfirmation) {
      this.collection.invalidate(
        "passwordConfirmation",
        "As duas senhas precisam ser idênticas"
      );
      
      this.forceUpdate();
    } else {
      this.props.loaderShow();
      
      let requestData = this.collection.toObject();
    
      this.setState({
        pendingRequest: true
      });
      
      ExecuteRequest(
        GlamboxEndpoints.Open.registerSimple,
        requestData,
        "POST",
        null,
        null,
        (response) => {
          let {
            result,
            statusCode
          } = response;
         
          this.props.loaderHide();
    
          this.setState({
            pendingRequest: false
          });
          
          if (statusCode === 200) {
            this.props.executeLogin(requestData["email"], requestData["password"]);
            this.props.publishSuccessAlert("Cadastro realizado com sucesso! Aguarde enquanto realizamos o seu login!");
          } else {
            console.error("ERROU");
            this.props.publishErrorAlert(
              (result && result.message) 
                ? result.message 
                : "Não foi possível realizar o seu cadastro, erro desconhecido."
            );
          }
        }
      );
    }
  }
}

// ----------------------------------------------------------------------

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => ({
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  executeLogin: (email, password) => {
    dispatch(TokenActions.login(email, password, true));
  }
});

RegisterForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterForm);

// ----------------------------------------------------------------------

export {
  RegisterForm
};